import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchSessionStarted = action(
    'ON_SEARCH_SESSION_STARTED_NEXT',
    (actionSource: string, shouldStartSearch: boolean, scenarioId: SearchScenarioId) => ({
        actionSource,
        shouldStartSearch,
        scenarioId,
    })
);

export default onSearchSessionStarted;
